import React, { useMemo, useState } from 'react';
import { Download, Eye } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { getPropertyDocumentDownloadUrl } from '../../services/api';
import { getFileKindFromUrl } from '../../utils/fileKind';

type Props = {
  title: string;
  fileUrl: string;
  downloadName?: string;
};

export const DocumentActions: React.FC<Props> = ({ title, fileUrl, downloadName }) => {
  const [open, setOpen] = useState(false);
  const href = useMemo(() => getPropertyDocumentDownloadUrl(fileUrl), [fileUrl]);
  const kind = useMemo(() => getFileKindFromUrl(href), [href]);

  const handleView = () => {
    if (kind === 'image') {
      setOpen(true);
      return;
    }
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <div className="flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={handleView}
          className="inline-flex items-center space-x-2 text-sm text-primary hover:text-primary/80 transition-colors"
        >
          <Eye className="w-4 h-4" />
          <span>{kind === 'image' ? 'Ver imagen' : kind === 'pdf' ? 'Ver PDF' : 'Ver'}</span>
        </button>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          download={downloadName}
          className="inline-flex items-center space-x-2 text-sm text-primary hover:text-primary/80 transition-colors"
        >
          <Download className="w-4 h-4" />
          <span>Descargar</span>
        </a>
      </div>

      {kind === 'image' && (
        <Modal isOpen={open} onClose={() => setOpen(false)} title={title} size="lg">
          <div className="space-y-4">
            <div className="rounded-lg border border-gray-200 overflow-hidden bg-black/5">
              <img src={href} alt={title} className="w-full h-auto max-h-[70vh] object-contain mx-auto" />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

